import { Injectable } from '@angular/core';
import { IKeyValue } from "../shared/keyvalue";

@Injectable()
export class AppSettings {

    //Local
    //public API_ENDPOINT = 'http://localhost:3000/api/';
    //Staging
    public API_ENDPOINT = 'https://informheathservice-staging.azurewebsites.net/api/';
    //Production
    //public API_ENDPOINT = 'https://informhealthservice.azurewebsites.net/api/';
    public PAGE_SIZE = 10;

    public GetRoles(): IKeyValue[] {
        var roles: IKeyValue[] = [];
        roles.push({ key: 'admin', value: 'Admin' });
        roles.push({ key: 'user', value: 'User' });
        return roles;
    };

    public GetLanguages(): IKeyValue[] {
        var languages: IKeyValue[] = [];
        languages.push({ key: 'en', value: 'English' });
        languages.push({ key: 'es', value: 'Spanish' });
        languages.push({ key: 'pl', value: 'Polish' });
        return languages;
    };

    public GetDirectories() {
        var directories: IKeyValue[] = [];
        directories.push({ key: 'resources', value: 'Resources' });
        directories.push({ key: 'facility', value: 'Facility' });
        directories.push({ key: 'facility/tutorial', value: 'Facility/Tutorial' });
        directories.push({ key: 'home', value: 'Home' });
        return directories;
    }

    public GetDisplayTypes(): IKeyValue[] {
        var displayTypes: IKeyValue[] = [];
        displayTypes.push({ key: 'card', value: 'Card' });
        displayTypes.push({ key: 'list', value: 'List' });
        return displayTypes;
    };

    public GetFileTypes(): IKeyValue[] {
        var fileTypes: IKeyValue[] = [];
        fileTypes.push({ key: 'image', value: 'Image' });
        fileTypes.push({ key: 'pdf', value: 'Pdf' });
        fileTypes.push({ key: 'video', value: 'Video' });
        fileTypes.push({ key: 'webpage', value: 'Web Page' });
        return fileTypes;
    };

    public GetContentTypes(): IKeyValue[] {
        var contentTypes: IKeyValue[] = [];
        contentTypes.push({ key: 'internal', value: 'Internal' });
        contentTypes.push({ key: 'external', value: 'External' });
        return contentTypes;
    };

    public GetStatus(): IKeyValue[] {
        var status: IKeyValue[] = [];
        status.push({ key: 'submitted', value: 'Submitted' });
        status.push({ key: 'cancelled', value: 'Cancelled' });
        status.push({ key: 'sent', value: 'Sent' });
        return status;
    };

    public GetPages(): IKeyValue[] {
        var pages: IKeyValue[] = [];
        pages.push({ key: 'HomePage', value: 'Home Page' });
        pages.push({ key: 'ContentDetailPage', value: 'Content Detail Page' });
        pages.push({ key: 'NewsfeedPage', value: 'Newsfeed Page' });
        return pages;
    };

    public toDatetimeLocal(date: Date): string {
        var
            ten = function (i) {
                return (i < 10 ? '0' : '') + i;
            },
            YYYY = date.getFullYear(),
            MM = ten(date.getMonth() + 1),
            DD = ten(date.getDate()),
            HH = ten(date.getHours()),
            II = ten(date.getMinutes()),
            SS = ten(date.getSeconds());

        return YYYY + '-' + MM + '-' + DD + 'T' +
            HH + ':' + II;
    };

    public GetDefaultImages(isDefault: Boolean) {
        if (isDefault) {
            return {
                loginLogo: "https://informhealth.blob.core.windows.net/generic/Facility/logo_login.png",
                appLogo: "https://informhealth.blob.core.windows.net/generic/Facility/logo_language.png",
                languageLogo: "https://informhealth.blob.core.windows.net/generic/Facility/logo_language.png",
                headerLogo: "https://informhealth.blob.core.windows.net/generic/Facility/logo_header.png",
                folder: "https://informhealth.blob.core.windows.net/generic/Facility/folder.png",
                image: "https://informhealth.blob.core.windows.net/generic/Facility/image.png",
                pdf: "https://informhealth.blob.core.windows.net/generic/Facility/pdf.png",
                video: "https://informhealth.blob.core.windows.net/generic/Facility/video.png",
                webpage: "https://informhealth.blob.core.windows.net/generic/Facility/webpage.png",
                homeScreenIcon192: "https://informhealth.blob.core.windows.net/generic/Facility/icon-192.png",
                homeScreenIcon512: "https://informhealth.blob.core.windows.net/generic/Facility/icon-512.png",
                homeScreenSplash: "https://informhealth.blob.core.windows.net/generic/Facility/splash.png"
            }
        } else {
            return {
                loginLogo: "https://informhealth.blob.core.windows.net/generic/Facility/logo_login.png",
                appLogo: "",
                languageLogo: "",
                headerLogo: "",
                folder: "",
                image: "",
                pdf: "",
                video: "",
                webpage: "",
                homeScreenIcon192: "",
                homeScreenIcon512: "",
                homeScreenSplash: ""
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/appSettings.ts